import { Button } from "../components/ui/Button";

// Lands here after Stripe Checkout redirects with a successful
// session. The actual user provisioning happens server-side in
// the stripe-webhook Edge Function — this page just tells the
// owner what to expect next so they don't bounce thinking nothing
// happened.

export function Welcome() {
  return (
    <div className="h-full w-full flex items-center justify-center bg-slate-100 px-4 py-10">
      <div className="w-full max-w-md bg-white border border-slate-200 rounded-lg shadow-sm p-6 text-center space-y-4">
        <div className="mx-auto w-12 h-12 rounded-full bg-emerald-100 text-emerald-700 flex items-center justify-center text-2xl">
          ✓
        </div>
        <h1 className="text-xl font-semibold text-slate-900">
          You're all set
        </h1>
        <p className="text-sm text-slate-600">
          Thanks for subscribing. We've sent an email to the address
          you used at checkout — click the link inside to set your
          password and finish setting up your agency.
        </p>
        <p className="text-xs text-slate-500">
          The email should arrive within a minute. If you don't see
          it, check spam.
        </p>
        <div className="pt-2">
          <Button variant="secondary"
            onClick={() => { window.location.hash = "#/login"; }}
            className="w-full"
          >
            I have my email — sign in
          </Button>
        </div>
      </div>
    </div>
  );
}
